import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { redeemProfileSetup } from "../../api/api";
import { adoptAccount } from "../../lib/sessionActions";
import { BrandLogo } from "../nav_panel/BrandLogo";

/**
 * Open the welcome-email link, start a session, and continue to profile setup.
 * @param {Object} props
 * @param {(user: object) => void} props.stageSession
 * @returns {JSX.Element}
 */
export default function ProfileSetupPage({ stageSession }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) {
      setError("This link is missing a token.");
      return undefined;
    }
    let cancelled = false;
    (async () => {
      const result = await redeemProfileSetup(token);
      if (cancelled) return;
      if (result.error || !result.data?.id) {
        setError(result.error || "This link is invalid or expired.");
        return;
      }
      const account = { ...result.data, type: result.data.type || "user" };
      if (result.token) {
        const adopted = await adoptAccount(account, result.token);
        if (adopted.error) {
          setError(adopted.error);
          return;
        }
      }
      stageSession(account);
      navigate(`/profile/${account.id}?setup=1`, { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate, stageSession, token]);

  return (
    <main className="min-h-full bg-primary px-6 py-16 text-text-primary">
      <div className="mx-auto flex w-full max-w-md flex-col">
        <div className="mb-16 flex justify-center">
          <BrandLogo />
        </div>
        {error ? (
          <div className="space-y-4">
            <p className="text-base text-text-primary" role="alert">
              {error}
            </p>
            <Link to="/login" className="text-sm text-accent">
              Log in
            </Link>
          </div>
        ) : (
          <p className="text-text-secondary">Opening your profile…</p>
        )}
      </div>
    </main>
  );
}
